// extracted by mini-css-extract-plugin
export var cyan = "LinkList-module--cyan--15c73";
export var description = "LinkList-module--description--2213e";
export var icon = "LinkList-module--icon--41e78";
export var link = "LinkList-module--link--9eef0";
export var red = "LinkList-module--red--0aa4a";
export var root = "LinkList-module--root--025fd";
export var url = "LinkList-module--url--ef6ad";